import catalog from './locales/public.json';

export const publicText = (lang, source, values = {}) => {
  if (typeof source !== 'string') return '';
  const text = catalog[source]?.[lang] || source;
  return text.replace(/\{([\w]+)\}/g, (match, key) => values[key] === undefined ? match : String(values[key]));
};

export const publicError = (lang, detail) => publicText(lang,
  typeof detail === 'string' && catalog[detail] ? detail : 'Please check your details and try again.');